import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Client, Home, Landing, Pricing, Privacy, Terms } from "./pages";
import { ScrollToTop } from "./components/ScrollToTop";

export const WebRoutes = () => {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route index path="/" element={<Landing />} />
          <Route path="/stylist" element={<Home />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/client" element={<Client />} />
          <Route path="/pricing" element={<Pricing />} />
        </Routes>
      </Router>
    </>
  );
};
